<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Personne à contacter dans l'entreprise</p>
        <p class="no-margin dark-gray text-sm">Toutes les informations de ce bloc sont obligatoires</p>
      </div>
    </div>
  </div>


  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid"
    class="p-20">

    <div>
      <p class="dark-blue no-margin">Nom <span class="red">*</span></p>
      <input [(ngModel)]="contact.name" (ngModelChange)="onContactChange()" type="text" name="name"
        id="contact-name" class="w-full text-md dark-blue pap-input" value="{{contact.name}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Prénom <span class="red">*</span></p>
      <input [(ngModel)]="contact.firstName" (ngModelChange)="onContactChange()" type="text" name="firstName"
        id="contact-firstName" class="w-full text-md dark-blue pap-input" value="{{contact.firstName}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Fonction dans l'entreprise <span class="red">*</span></p>
      <input [(ngModel)]="contact.occupation" (ngModelChange)="onContactChange()" type="text" name="occupation"
        id="contact-occupation" class="w-full text-md dark-blue pap-input" value="{{contact.occupation}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Numéro de téléphone <span class="red">*</span></p>
      <input [(ngModel)]="contact.phone" (ngModelChange)="onContactChange()" type="text" name="phone"
        id="contact-phone" class="w-full text-md dark-blue pap-input" value="{{contact.phone}}"
        (keypress)="onlyNumbers($event)" pattern="[0-9]*" inputmode="numeric" maxlength="10">
    </div>

    <div>
      <p class="dark-blue no-margin">Adresse courriel <span class="red">*</span></p>
      <input [(ngModel)]="contact.mail" (ngModelChange)="onContactChange()" type="text" name="mail"
        id="contact-mail" class="w-full text-md dark-blue pap-input" value="{{contact.mail}}">
    </div>

  </div>
</div>